<div class="sorting-item" [formGroup]="sortingGroup">
  <div class="sorting-item__drag-drop"><span class="material-symbols-outlined">drag_indicator</span></div>
  <app-column-picker
    [treeNodes]="treeNodes"
    [required]="true"
    [preselectedColumnKey]="sortingGroup.get('columnKey')?.value"
    [type]="type"
    (selectedColumnKey)="selectColumn($event)"></app-column-picker>
  <mat-form-field>
    <mat-select formControlName="direction">
      <mat-option value="Asc">Ascending</mat-option>
      <mat-option value="Desc">Descending</mat-option>
    </mat-select>
  </mat-form-field>
  <span class="material-symbols-outlined sorting-item__delete-icon" (click)="ruleDeleted.emit()">delete</span>
</div>
